"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BgAPIUserLocationComponentParameters = void 0;
exports.BgAPIUserLocationComponentParameters = [
    {
        id: 'skipOnFailure',
        label: 'Skip on Failure',
        description: 'Input Param - Skip this component if the API call fails',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'locality',
        label: 'Locality',
        description: 'Output Param - Village or city retrieved from the user location',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'adminArea',
        label: 'Administrative Area',
        description: 'Output Param - Administrative area (e.g., state) retrieved from the user location',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'postalCode',
        label: 'Postal Code',
        description: 'Output Param - Postal code retrieved from the user location',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'countryCode',
        label: 'Country Code',
        description: 'Output Param - Country code (e.g., "IN") retrieved from the user location',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'countryName',
        label: 'Country Name',
        description: 'Output Param - Country name (e.g., "India") retrieved from the user location',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
];
//# sourceMappingURL=BgAPIUserLocationComponent.js.map